import { ITenant, IncentiveProduct } from "@oneethos/shared"

type IncentiveLoanCardProps = {
  financingTenant: ITenant
  financingPartnerLogo: string
  incentiveProduct: IncentiveProduct
  showSavings?: boolean
  isConsumerView?: boolean
  isDisabled?: boolean
  getProduct?: () => void
  isSelected?: boolean
}

const IncentiveLoanCard = ({
  financingTenant,
  incentiveProduct,
  financingPartnerLogo,
  isSelected,
  isConsumerView,
  isDisabled,
  getProduct,
  showSavings = true
}: IncentiveLoanCardProps) => {
  const classes = isConsumerView
    ? [
      isDisabled && 'opacity-50 pe-none',
      isSelected && 'selected',
    ].filter(Boolean).join(' ')
    : 'border rounded-2'

  const visibilityClass = showSavings ? "" : "hide-savings-estimate"

  return (
    <div className={[`card loan-option-card`, classes, 'incentive'].filter(Boolean).join(' ')}>
      <div className="my-3">
        <div className="detail-wrap">
          <div
            className={`loan-detail ${visibilityClass}`}
            dangerouslySetInnerHTML={{ __html: incentiveProduct.loanDetailHTML }}
          />
        </div>
      </div>
      <div>
        <img src={`/api/tenant/logo/${financingTenant._id}`} loading="lazy" id="logo" className="logo" />
        <div>
          <p>In partnership with:</p>
          <img src={financingPartnerLogo} loading="lazy" id="logo" className="logo" />
        </div>
      </div>
      {isConsumerView ? <>
        {isSelected ? <div className="is-selected mt-3">Selected</div> : <button
          className={`btn mt-3 btn-${isDisabled ? `outline-secondary` : `primary`}`}
          disabled={isDisabled}
          onClick={getProduct}
        >
          {isDisabled ? 'Not Eligible' : 'Select'}
        </button>}
      </> : null}
    </div>
  )
}

export default IncentiveLoanCard
